import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hall-filter"
export default class extends Controller {
  static targets = ["search", "select"]

  connect() {
    // 全てのoptionを保存（初期状態）
    this.allOptions = Array.from(this.selectTarget.options)
  }

  filter() {
    const searchText = this.searchTarget.value.toLowerCase()
    const select = this.selectTarget

    // セレクトボックスを一旦空にする
    select.innerHTML = ""

    // promptオプション（"ホールを選択してください"）を追加
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = "ホールを選択してください"
    select.appendChild(promptOption)

    // フィルタリングして該当するoptionを追加
    this.allOptions.forEach(option => {
      if (option.value === "") return // promptはスキップ

      const optionText = option.textContent.toLowerCase()
      if (optionText.includes(searchText)) {
        select.appendChild(option.cloneNode(true))
      }
    })
  }
}
